import { __decorate, __metadata } from "tslib";
import { SerializableMember, SerializableObject } from '@openhps/core';
import { activitystreams } from '../../terms';
let Activity = class Activity {
};
__decorate([
    SerializableMember({
        rdf: {
            predicate: activitystreams.object,
            serializer: false,
        },
    }),
    __metadata("design:type", String)
], Activity.prototype, "object", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicate: activitystreams.actor,
            serializer: false,
        },
    }),
    __metadata("design:type", String)
], Activity.prototype, "actor", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicate: activitystreams.target,
            serializer: false,
        },
    }),
    __metadata("design:type", String)
], Activity.prototype, "target", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicate: activitystreams.published,
        },
    }),
    __metadata("design:type", Date)
], Activity.prototype, "published", void 0);
Activity = __decorate([
    SerializableObject({
        rdf: {
            type: activitystreams.Activity,
        },
    })
], Activity);
export { Activity };
//# sourceMappingURL=Activity.js.map